import { render, staticRenderFns } from "./SystemArticle.vue?vue&type=template&id=217ec04b&scoped=true&"
import script from "./SystemArticle.vue?vue&type=script&lang=js&"
export * from "./SystemArticle.vue?vue&type=script&lang=js&"
import style0 from "./SystemArticle.vue?vue&type=style&index=0&id=217ec04b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ec04b",
  null
  
)

export default component.exports